'use client'

import { Button } from '@algoacademy/design-system/web/actions/Button'
import { DiscordLogo, GitHubLogo, GoogleLogo } from '@algoacademy/design-system/web/svg/logos'
import { useSearchParams } from 'next/navigation'
import { authClient } from '@/app/_auth/auth-client'
import { resolveRedirect } from '@/app/auth/_helpers/resolve-redirect'

export function OAuthRegisterButtons() {
  const searchParams = useSearchParams()
  const redirectTo = resolveRedirect(
    searchParams.get('redirectTo') ?? searchParams.get('callbackUrl')
  ).url

  return (
    <div className='flex flex-col items-center justify-center gap-3 sm:flex-row'>
      <Button
        outline
        className='w-full'
        onClick={() => authClient.signIn.social({ provider: 'google', callbackURL: redirectTo })}
      >
        <GoogleLogo />
        Google
      </Button>
      <Button
        outline
        className='w-full'
        onClick={() => authClient.signIn.social({ provider: 'github', callbackURL: redirectTo })}
      >
        <GitHubLogo />
        GitHub
      </Button>
      <Button
        outline
        className='w-full'
        onClick={() => authClient.signIn.social({ provider: 'discord', callbackURL: redirectTo })}
      >
        <DiscordLogo />
        Discord
      </Button>
    </div>
  )
}
